import React, { useState } from 'react';
import EnterEmail from '@components/AuthComponents/EnterEmail';
import VerifyCode from '@components/AuthComponents/VerifyCode';

const AuthScreen = () => {
  const [email, setEmail] = useState('');
  const [isVerifyScreen, updateIsVerifyScreen] = useState(false);

  if (isVerifyScreen) return <VerifyCode email={email} />;

  return (
    <EnterEmail
      email={email}
      setEmail={setEmail}
      updateIsVerificationScreen={updateIsVerifyScreen}
    />
  );
};

export default AuthScreen;
